// Stacking is split into isolated root layers defined in public/index.html,
// painted in DOM order without z-index:
//   #app (page) < #popup-layer < #notification-layer < #tooltip-layer
// A z-index only orders elements inside its own layer, so the values stay small.
//
// Components with internal layering (KVideoPlayer, KBadge, .ks-dropdown, the
// video editor timeline, third-party widgets...) isolate their root and number
// their internals from 1, so nothing inside them leaks into the page scale.
export const Z_INDEX = {
	// Page (#app)
	sticky: 1,            // sticky list/table headers
	editorFullscreen: 2,  // MarkDown editor in SimpleMDE fullscreen mode
	pageControls: 3,      // floating ActionButtons, sidebar resize handle
	searchBar: 4,         // search results dropdown
	drawer: 4,
	drawerOverlay: 5,
	drawerTemporary: 6,
	loading: 7,           // loading / maintenance overlays
	// #popup-layer: popupStack.js gives each opened popup (menu, dialog,
	// dropdown) popupBase + popupStep above the previous one: 1, 2, 3...
	popupBase: 0,
	popupStep: 1
}

function toKebab (key) {
	return key.replace(/[A-Z]/g, (c) => "-" + c.toLowerCase())
}

// Exposes the layers as CSS variables (--ks-z-drawer, --ks-z-popup-base, ...)
// so stylesheets can use the same values as JS.
export function installZIndexVariables (root = document.documentElement) {
	Object.keys(Z_INDEX).forEach((key) => {
		root.style.setProperty("--ks-z-" + toKebab(key), String(Z_INDEX[key]))
	})
}
